<template>
    <div class="row ml-xl-4 m-0">
        <div class="col-md-12 col-sm-8">
            <h3>
                <b>Eventos asistidos: </b>
            </h3> 
        </div>               
        <div class="col-md-12 col-sm-8 scroll-table" v-if="eventos.length > 0">
            <table class="mt-3 table">
                <thead>
                    <tr>
                        <th>Evento</th>
                        <th class="text-center">Hora Entrada</th>
                        <th class="text-center">Temporada</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(evento, index) in eventos">
                        <tr :key="index">
                            <td >{{ evento.nombre }}</td>
                            <td class="text-center">{{ evento.hora_entrada }}</td>
                            <td class="text-center">{{ temporada }}</td>
                        </tr>
                    </template>                    
                </tbody>
            </table>
        </div>
        <div class="col-md-12 col-sm-8" v-else>
            <p>Este abonado no ha asistido a ningún evento.</p>
        </div>
    </div>    
</template>

<script>
    export default {
        props: {
            eventos: Array,
            temporada: String
        },
    }
</script>

<style scoped>
    .scroll-table {
        overflow-y: scroll;
        height: 200px;
    }
</style>